export const AUTH = "/auth/login";
export const REFRESH_TOKEN = "/auth/refresh-token";
